/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import Icon, { GLYPHS } from '../../common/icon';
import Switch from '../../common/Switch';

const ScheduleRecurringCampaignHeader = ({
  isLapsedCampaign,
  recurringDangerSwitch,
  onSendToAllCustomersToggle,
  showMoreInfo,
  setShowMoreInfo,
}) => (
  <div className="u-max-width-530 u-margin-auto u-p-">
    {isLapsedCampaign &&
      <div>
        <div>This is a lapsed campaign – you can set the frequency with which we check if there is a new customer who has become lapsed.</div>
        <div className="u-mt">Campaigns will only be sent to those customers who have become newly lapsed, to ensure that the same person does not receive multiple messages for the same campaign.</div>
        <button
          className="c-btn--blank c-link-button c-btn--link u-block u-mt-"
          onClick={() => setShowMoreInfo(!showMoreInfo)}
        >
          See More <Icon glyph={GLYPHS.chevronDropdown} size="nano" className={showMoreInfo ? 'u-rotate-180' : ''} />
        </button>
      </div>
    }
    {!isLapsedCampaign &&
      <div>This is a custom campaign - you can set the frequency with which the campaign will be sent.
        <button
          className="c-btn--blank c-link-button c-btn--link u-block u-mt-"
          onClick={() => setShowMoreInfo(!showMoreInfo)}
        >
          See More <Icon glyph={GLYPHS.chevronDropdown} size="nano" className={showMoreInfo ? 'u-rotate-180' : ''} />
        </button>
      </div>
    }
    <div
      className="u-mt-"
      display-if={showMoreInfo}
    >
      Recurring campaigns have a default setting to prevent your customers from receiving the same campaign more than once in a 30 day period.
      <span className="u-type--bold u-font-color-red"> You can turn this setting off, however this is not recommended.  Customers who receive too many redundant messages are more likely to unsubscribe.</span>
      <div className="layout__item u-mt u-pl-- u-mb--">
        <Switch
          name={'recurringSendToAllCustomers'}
          label={recurringDangerSwitch ? 'Enabled' : 'Disabled'}
          checked={recurringDangerSwitch} onChange={onSendToAllCustomersToggle}
        />
      </div>
      <div
        className="u-mt-- u-font-color-red c-engagement-modal__warning_message"
        display-if={!recurringDangerSwitch}
      >
        * Disabling this feature is not recommended.
      </div>
    </div>
  </div>
);

ScheduleRecurringCampaignHeader.propTypes = {
  isLapsedCampaign: PropTypes.bool.isRequired,
  recurringDangerSwitch: PropTypes.bool.isRequired,
  onSendToAllCustomersToggle: PropTypes.func.isRequired,
  showMoreInfo: PropTypes.bool.isRequired,
  setShowMoreInfo: PropTypes.func.isRequired,
};

export default ScheduleRecurringCampaignHeader;
